import request from '@/utils/request'

/**
 * 获取商家列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function listStores(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/store.listStores',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取店铺员工列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function listStoreStaffs(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeStaff.listStoreStaff',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}